import { Button, cn } from '@newfront-insurance/core-ui/v2';

import { ToolHandoffCardFooter } from './primitives/tool-handoff-card';
import { novaGradientClass } from '../../design-system/gradients';

export function NovaScheduleEditorFooter({
  disabled,
  onBack,
  onUpdate,
}: {
  disabled: boolean;
  onBack: () => void;
  onUpdate?: () => void;
}) {
  return (
    <ToolHandoffCardFooter className="px-[27px] py-5">
      <Button
        type="button"
        variant="tertiary"
        className="h-auto px-0 py-0 text-[14px] leading-5"
        disabled={disabled}
        onClick={onBack}
      >
        Back
      </Button>

      {onUpdate && (
        <Button
          type="button"
          variant={null}
          className={cn(
            'text-wtw-ultraviolet-850 hover:text-wtw-ultraviolet-850 h-9 rounded-full px-4 py-2 text-[14px] leading-5',
            novaGradientClass.aiBackground,
          )}
          disabled={disabled}
          onClick={onUpdate}
        >
          Update
        </Button>
      )}
    </ToolHandoffCardFooter>
  );
}
